module.exports = __webpack_public_path__ + "static/media/UA.1c23b8c9.svg";